import React from 'react';
import { Form, TextInput, UploadInput } from '@thinknet-gmbh/platform-common-ui';

import { useTranslation } from 'react-i18next';
import { HealthInsuranceCardWrapper } from './health-insurance-card.styles';
import { UploadFile } from 'antd/es/upload/interface';

const HealthInsuranceCard = () => {
  const { t } = useTranslation('employee');

  return (
    <HealthInsuranceCardWrapper>
      <Form.Item
        className={'form-item-select'}
        rules={[{ required: true, message: t('customers:error.fieldIsRequired') }]}
        name={['paymentAndInsurance', 'healthInsuranceCardName']}
        label={t(`employee:questionnaire.paymentAndInsurance.labels.healthInsuranceCardName`)}
      >
        <TextInput
          placeholder={t(
            `employee:questionnaire.paymentAndInsurance.placeholders.healthInsuranceCardName`
          )}
          maxLength={32}
        />
      </Form.Item>
      <Form.Item noStyle shouldUpdate>
        {({ getFieldValue }) => {
          const personalIdCardBack = getFieldValue('healthInsuranceCardId');
          return (
            <Form.Item
              name="healthInsuranceCardId"
              className={'health-insurance-id-file-field'}
              valuePropName="file"
              rules={[
                {
                  required: true,
                  message: t('common:validation.error.fieldRequired'),
                },
                {
                  validator: (
                    _: any,
                    value: {
                      file?: UploadFile;
                    }
                  ) => {
                    const file = value?.file;
                    return file?.status !== 'removed'
                      ? Promise.resolve()
                      : Promise.reject(new Error(t('common:validation.error.fieldRequired')));
                  },
                },
              ]}
              label={t('employee:questionnaire.paymentAndInsurance.labels.healthInsuranceCard')}
            >
              <UploadInput
                showUploadList
                beforeUpload={() => false}
                variant="DashedContainer"
                btnText={t('settings:documents.buttons.uploadFile')}
                accept=".jpg, .jpeg, .png"
                maxCount={1}
                defaultFileList={
                  personalIdCardBack
                    ? [
                        {
                          uid: personalIdCardBack?.file?.key,
                          name: personalIdCardBack?.file?.name,
                          url: personalIdCardBack?.file?.location,
                        },
                      ]
                    : undefined
                }
              />
            </Form.Item>
          );
        }}
      </Form.Item>
    </HealthInsuranceCardWrapper>
  );
};

export default HealthInsuranceCard;
